import React from "react";
import PolicyLayout from "../components/PolicyLayout";

const refundPolicyContent = [
  {
    id: "return-window",
    title: "Return Window",
    content:
      "Customers can request a return or refund within 7 days of delivery. The saree must be unused, unworn, unwashed, and returned with original packaging, tags, invoice, and any blouse piece or accessories received with the order.",
  },
  {
    id: "eligible-items",
    title: "Eligible Items",
    content:
      "Refunds are applicable for sarees received in damaged condition, incorrect products, wrong color or design shipped, or items with clear manufacturing defects reported within the return window.",
  },
  {
    id: "non-returnable-items",
    title: "Non-Returnable Items",
    content:
      "Used, washed, altered, fall/pico completed, customized, made-to-order, blouse-stitched, or damaged-by-customer sarees are not eligible for refund. Minor color variation caused by screen display or lighting is not treated as a product defect.",
  },
  {
    id: "damage-reporting",
    title: "Damaged Or Wrong Product",
    content:
      "If you receive a damaged or incorrect saree, please contact us with your order number, photos of the product, packaging, and invoice. This helps our team verify the issue quickly and guide you through the next step.",
  },
  {
    id: "refund-process",
    title: "Refund Process",
    content:
      "Once the returned product is received and inspected, approved refunds will be processed to the original payment method. Depending on your bank or payment provider, the amount may take 5 to 10 business days to reflect.",
  },
  {
    id: "shipping-charges",
    title: "Shipping Charges",
    content:
      "Shipping charges are refundable only when the return is due to a wrong, defective, or damaged product shipped by Tanuraaga. For other approved returns, reverse shipping charges may be deducted from the refund amount.",
  },
  {
    id: "exchange-option",
    title: "Exchange Option",
    content:
      "Where possible, customers may choose an exchange instead of a refund. Exchange approval depends on product availability, product condition, and verification by our support team.",
  },
  {
    id: "support-contact",
    title: "Need Help?",
    content:
      "For refund or return assistance, contact us at tanuraaga.weaves@gmail.com or +91 7411134054 with your order details. Our team will help you with the refund request and required documentation.",
  },
];

const CustomerRefundPolicyPage = () => (
  <PolicyLayout
    activeLabel="Refund Policies"
    className="refund-policy-page"
    title="Customer Refund Policies"
    intro={{
      title: "Our Promise",
      content:
        "At Tanuraaga, every saree is packed with care. If something is not right with your order, we want the return and refund process to be simple, fair, and transparent.",
    }}
    sections={refundPolicyContent}
  />
);

export default CustomerRefundPolicyPage;
